/**
 * Bus de un solo listener que desacopla deliverPdf (código vanilla) del
 * PdfPreviewProvider (componente React). Solo puede haber un modal activo a la vez.
 */

let _listener = null;

/**
 * Suscribirse a eventos de preview. Devuelve función para desuscribirse.
 * @param {(payload: { blob: Blob, fileName: string, title?: string, compartir?: object|null }) => void} fn
 */
export const subscribePdfPreview = (fn) => {
  _listener = fn;
  return () => {
    if (_listener === fn) _listener = null;
  };
};

/**
 * Emitir un nuevo PDF para mostrar en el modal.
 * @param {{ blob: Blob, fileName: string, title?: string, compartir?: object|null }} payload
 */
export const emitPdfPreview = (payload) => {
  if (_listener) {
    _listener(payload);
  }
};
